import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useAction = (action) => {
  const dispatch = useDispatch();

  return useCallback(
    (...args) => dispatch(action(...args)),
    [dispatch, action],
  );
};

/* eslint-disable react-hooks/exhaustive-deps */
export const useActionWithEffect = (action, deps = [], ...args) => {
  const actionToUse = useAction(action);
  useEffect(() => {
    actionToUse(...args);
  }, [...deps]);
};
